/* ─── Styles de voyage ──────────────────────────────────────── */
export const TRIP_STYLES = [
  { id: 'beach',      label: 'Plage',              labelKey: 'trip_style_beach',      icon: '🏖️', occasions: ['casual','sport','evening'] },
  { id: 'city',       label: 'City break',          labelKey: 'trip_style_city',       icon: '🏙️', occasions: ['casual','work','evening','dinner'] },
  { id: 'mountain',   label: 'Montagne',            labelKey: 'trip_style_mountain',   icon: '🏔️', occasions: ['sport','casual'] },
  { id: 'business',   label: "Voyage d'affaires",   labelKey: 'trip_style_business',   icon: '💼', occasions: ['work','dinner','evening'] },
  { id: 'wedding',    label: 'Mariage / Gala',      labelKey: 'trip_style_wedding',    icon: '💍', occasions: ['evening','dinner'] },
  { id: 'backpacker', label: 'Backpacker',          labelKey: 'trip_style_backpacker', icon: '🎒', occasions: ['casual','sport'] },
  { id: 'luxury',     label: 'Luxe / Resort',       labelKey: 'trip_style_luxury',     icon: '🥂', occasions: ['evening','dinner','casual'] },
  { id: 'safari',     label: 'Safari / Nature',     labelKey: 'trip_style_safari',     icon: '🌿', occasions: ['casual','sport'] },
];

/* ─── Météo ─────────────────────────────────────────────────── */
export const WEATHER_PROFILES = {
  hot_dry:   { icon: '☀️', label: 'Chaud et sec',    temp: '30-40°C', advice: 'Privilegier les matieres legeres et respirantes' },
  hot_humid: { icon: '🌴', label: 'Chaud et humide', temp: '28-35°C', advice: 'Coton et lin seulement' },
  temperate: { icon: '🌤', label: 'Tempere',         temp: '15-25°C', advice: 'Superposition recommandee, veste legere' },
  cold:      { icon: '🧥', label: 'Froid',           temp: '0-15°C',  advice: 'Laines, doudounes, superposition' },
  very_cold: { icon: '❄️', label: 'Tres froid',      temp: '-10-5°C', advice: 'Doudoune technique, sous-vetements thermiques' },
  rainy:     { icon: '🌧️', label: 'Pluvieux',        temp: '10-20°C', advice: 'Impermeable, matieres sechant vite' },
  tropical:  { icon: '🌺', label: 'Tropical',        temp: '25-32°C', advice: 'Leger, couleurs claires, protection solaire' },
};

/* ─── Voyages mock ──────────────────────────────────────────── */
export const initialTrips = [];

/* ─── Suggestions selon le style ───────────────────────────── */
export const DONT_FORGET_BY_STYLE = {
  beach:      ['Lunettes de soleil', 'Creme solaire', '2 maillots minimum', 'Sandales impermeable', 'After-sun'],
  city:       ['Veste legere', 'Chaussures de marche', 'Parapluie compact', 'Petit sac a dos'],
  mountain:   ['Chaussures de randonnee', 'Impermeable', 'Gants', 'Echarpe', 'Sous-vetements thermiques'],
  business:   ['Sac de travail', 'Cable laptop', 'Adaptateur universel', '2 chemises de rechange'],
  wedding:    ['Tenue de ceremonie', 'Chaussures de soiree', 'Make-up', 'Pochette de soiree', 'Bijoux'],
  backpacker: ['Sac a dos leger', 'Vetements sechage rapide', 'Cadenas', 'Pharmacie basique', 'Power bank'],
  luxury:     ['Tenues de gala', 'Bijoux fins', 'Tenues cocktail x2', 'Kit spa'],
  safari:     ['Vetements aux couleurs neutres', 'Veste legere pour les nuits', 'Chaussures fermees', 'Anti-moustiques'],
};

// ═══ Checklist catégorisée pour voyage (utilisée pour enrichir l'écran "À ne pas oublier") ═══
// icons + categories groupées pour un affichage visuel structuré
export const TRAVEL_CHECKLIST = {
  documents: {
    label: 'Documents',
    icon: '📄',
    color: '#3B82F6',
    items: {
      common:  ['Passeport / CNI', 'Billets de transport', 'Permis de conduire', 'Carte bancaire'],
      beach:   ['Attestation assurance voyage'],
      mountain:['Carte d\'identité, licence sport si besoin'],
      business:['Badge professionnel', 'Cartes de visite'],
      wedding: ['Faire-part / invitation'],
      luxury:  ['Carte de membre spa/club'],
      safari:  ['Visa', 'Certificat vaccin fièvre jaune'],
      backpacker: ['Copie passeport (séparée)', 'Carnet contacts d\'urgence'],
    },
  },
  tech: {
    label: 'Électronique',
    icon: '🔌',
    color: '#8B5CF6',
    items: {
      common:  ['Chargeur téléphone', 'Écouteurs', 'Adaptateur universel', 'Batterie externe'],
      business:['Chargeur laptop', 'Câble HDMI', 'Souris', 'Casque audio'],
      beach:   ['Appareil photo étanche'],
      mountain:['GPS ou app hors-ligne', 'Lampe frontale'],
      safari:  ['Zoom appareil photo', 'Jumelles'],
      luxury:  ['Tablette / Kindle'],
    },
  },
  health: {
    label: 'Santé & pharmacie',
    icon: '💊',
    color: '#EF4444',
    items: {
      common:  ['Paracétamol', 'Pansements', 'Thermomètre'],
      beach:   ['Crème solaire SPF50', 'After-sun', 'Anti-moustiques'],
      mountain:['Anti-ampoules', 'Couverture de survie', 'Pommade anti-inflammatoire'],
      safari:  ['Anti-moustiques DEET', 'Traitement anti-palu', 'Réhydratation orale'],
      business:['Gouttes yeux (écran)', 'Probiotique voyage'],
      backpacker: ['Purificateur d\'eau', 'Kit premiers secours complet'],
    },
  },
  beauty: {
    label: 'Hygiène & beauté',
    icon: '🧴',
    color: '#EC4899',
    items: {
      common:  ['Brosse à dents + dentifrice', 'Déodorant', 'Shampoing format voyage', 'Gel douche'],
      beach:   ['Shampoing post-plage', 'Crème hydratante corps'],
      wedding: ['Make-up complet', 'Parfum', 'Laque/coiffant'],
      luxury:  ['Parfum de marque', 'Masque visage', 'Kit manucure'],
      business:['Rasoir + mousse à raser', 'Lingettes antibactériennes'],
    },
  },
  accessories: {
    label: 'Accessoires mode',
    icon: '👜',
    color: '#F59E0B',
    items: {
      beach:    ['Lunettes de soleil', 'Chapeau de plage', 'Sac de plage'],
      city:     ['Sac à dos discret', 'Écharpe légère', 'Parapluie compact'],
      mountain: ['Bonnet', 'Gants', 'Écharpe thermique', 'Bandana'],
      business: ['Attaché-case / sacoche', 'Ceinture cuir', 'Montre classique'],
      wedding:  ['Pochette de soirée', 'Bijoux de cérémonie'],
      luxury:   ['Sac de marque', 'Bijoux fins', 'Foulard soie'],
      safari:   ['Casquette anti-UV', 'Bandana léger'],
      backpacker: ['Cadenas voyage', 'Pochette cou anti-vol'],
    },
  },
  misc: {
    label: 'Pratique',
    icon: '🎒',
    color: '#10B981',
    items: {
      common:    ['Bouteille d\'eau réutilisable', 'Sac plastique pour linge sale'],
      beach:     ['Serviette microfibre', 'Sac étanche téléphone'],
      mountain:  ['Gourde isotherme', 'Barres énergétiques', 'Couteau multi-outils'],
      business:  ['Stylos', 'Carnet notes', 'Post-its'],
      backpacker:['Cordelette', 'Sac compression', 'Cuillère pliante'],
    },
  },
};

// Helper : récupérer les items applicables à un style (common + style-spécifique)
export function getChecklistForStyle(style) {
  const result = {};
  for (const [catKey, cat] of Object.entries(TRAVEL_CHECKLIST)) {
    const items = [
      ...(cat.items.common || []),
      ...(cat.items[style] || []),
    ];
    if (items.length > 0) {
      result[catKey] = {
        label: cat.label,
        icon:  cat.icon,
        color: cat.color,
        items,
      };
    }
  }
  return result;
}

/* ─── Mapping occasion → label français ─────────────────────── */
const OCC_LABEL = {
  casual: 'Decontracte',
  work: 'Professionnel',
  evening: 'Soiree',
  dinner: 'Diner',
  sport: 'Sport',
  beach: 'Plage',
};

/* ─── Tips par occasion + meteo ─────────────────────────────── */
const TIPS = {
  casual: {
    hot_dry:   'Lin et coton sont tes meilleurs allies par forte chaleur.',
    hot_humid: 'Matieres naturelles et coupe ample pour rester au frais.',
    temperate: 'Superpose une veste legere, les temperatures peuvent varier.',
    cold:      'Ajoute une echarpe et des collants pour rester au chaud.',
    rainy:     'Imperméable leger et chaussures impermeable indispensables.',
    tropical:  'Couleurs claires et matieres respirantes pour le soleil.',
    very_cold: 'Base layer thermique + manteau chaud obligatoire.',
  },
  work: {
    temperate: 'Un blazer structure suffit a elever ta tenue au niveau pro.',
    cold:      'Manteau classe par-dessus ton tailleur pour les deplacement.',
    hot_dry:   'Prefere les tissus anti-transpiration et les coupes aerees.',
    hot_humid: 'Lin ou bambou : frais et presentable pour le bureau.',
  },
  evening: {
    hot_dry:   'Une robe legere en soie ou satin, parfaite pour les soirees chaudes.',
    temperate: 'Ajoute un petit foulard pour les soirees fraiches en terrasse.',
    cold:      'Veste en velours ou manteau elegant par-dessus ta robe.',
    tropical:  'Robe fluide et sandales, tu seras parfaite pour la soiree.',
  },
  dinner: {
    temperate: 'Un ensemble chic sobre : moins c\'est plus pour un diner.',
    hot_dry:   'Tenue legere mais soignee, evite les matieres qui transpercent.',
    cold:      'Gilet fin ou blazer par-dessus pour rester elegant et chaud.',
  },
  sport: {
    cold:      'Superpose les couches : base, isolant, coupe-vent.',
    temperate: 'Tenue respirante et chaussures adaptees au terrain.',
    hot_dry:   'Protection UV et matiere sechant vite indispensable.',
  },
};

function getTip(occ, weather) {
  return TIPS[occ]?.[weather] || "L'essentiel est de te sentir a l'aise et de reflecter ta personnalite.";
}

/* ─── Algo de matching couleurs (simplifie) ─────────────────── */
function colorScore(c1, c2) {
  if (!c1 || !c2) return 50;
  const a = c1.toLowerCase();
  const b = c2.toLowerCase();
  if (a === b) return 85;
  const NEUTRALS = ['noir', 'blanc', 'beige', 'gris', 'marine', 'camel', 'ecru', 'ivoire', 'creme'];
  const isNeutralA = NEUTRALS.some(n => a.includes(n));
  const isNeutralB = NEUTRALS.some(n => b.includes(n));
  if (isNeutralA && isNeutralB) return 90;
  if (isNeutralA || isNeutralB) return 80;
  // Associations connues
  const pairs = [
    ['bleu','blanc'],['bleu','beige'],['rouge','noir'],['vert','beige'],
    ['bordeaux','camel'],['rose','gris'],['marine','blanc'],['kaki','blanc'],
  ];
  for (const [x, y] of pairs) {
    if ((a.includes(x) && b.includes(y)) || (a.includes(y) && b.includes(x))) return 88;
  }
  return 55;
}

/* ─── Génération des looks ────────────────────────────────────
   Utilise les VRAIES catégories françaises du dressing :
   Robes, Hauts, Bas, Vestes, Chaussures, Sacs, Bijoux, Accessoires
──────────────────────────────────────────────────────────── */
export function generateTravelLooks(packedItems, tripStyle, weather, seed = 0, maxTotal = 10, maxPerOccasion = 3) {
  if (!packedItems || packedItems.length === 0) return [];

  // RNG déterministe basé sur le seed (mulberry32)
  // Si seed = 0 → on utilise Math.random pur (premier chargement)
  const rand = seed === 0
    ? Math.random
    : (() => {
        let s = seed;
        return () => {
          s = (s + 0x6D2B79F5) | 0;
          let t = Math.imul(s ^ (s >>> 15), 1 | s);
          t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
          return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        };
      })();

  // Regrouper par categorie française
  const by = {};
  packedItems.forEach(item => {
    const cat = item.category || '';
    if (!by[cat]) by[cat] = [];
    by[cat].push(item);
  });

  // Aliases : si les items ont des catégories en anglais ou variantes
  const CAT_ALIASES = {
    'Robes':       ['Robes','robes','dresses','Robe','robe'],
    'Hauts':       ['Hauts','hauts','tops','Top','Haut','haut','Chemises','chemises'],
    'Bas':         ['Bas','bas','bottoms','Bottom','Pantalons','pantalons','Jupes','jupes','Jean','jean'],
    'Vestes':      ['Vestes','vestes','jackets','Veste','veste','Manteaux','manteaux','blazer','Blazer'],
    'Chaussures':  ['Chaussures','chaussures','shoes','Shoe','shoe'],
    'Sacs':        ['Sacs','sacs','bags','Bag','bag','Sac','sac'],
    'Bijoux':      ['Bijoux','bijoux','Bijou','jewelry','accessories_jewelry'],
    'Accessoires': ['Accessoires','accessoires','accessories','Accessoire'],
  };

  // Remplir by[] avec les aliases
  const normalized = {};
  for (const [stdCat, aliases] of Object.entries(CAT_ALIASES)) {
    normalized[stdCat] = [];
    for (const alias of aliases) {
      if (by[alias]) normalized[stdCat].push(...by[alias]);
    }
    // Deduplicate
    const seen = new Set();
    normalized[stdCat] = normalized[stdCat].filter(i => {
      if (seen.has(i.id)) return false;
      seen.add(i.id);
      return true;
    });
  }

  const occasions = TRIP_STYLES.find(s => s.id === tripStyle)?.occasions || ['casual'];
  const looks = [];

  // Générer plusieurs combinaisons par occasion
  occasions.forEach((occ, occIdx) => {
    const candidates = [];

    // ── Stratégie 1 : Robe + accessories ──
    if (normalized['Robes'].length > 0) {
      normalized['Robes'].forEach((robe, ri) => {
        const look = {
          id: `tl_${occ}_robe_${ri}`,
          name: OCC_LABEL[occ] || occ,
          occasion: occ,
          items: [robe.id],
          itemDetails: [robe],
          colors: [robe.color],
          score: 70,
          aiTip: '',
          missingItems: [],
        };

        // Choisir une chaussure dans le top 3 couleur (aléatoire si seed > 0)
        if (normalized['Chaussures'].length > 0) {
          const scored = normalized['Chaussures']
            .map(s => ({ s, score: colorScore(robe.color, s.color) }))
            .sort((a, b) => b.score - a.score);
          const pool = scored.slice(0, Math.min(3, scored.length));
          const shoe = pool[Math.floor(rand() * pool.length)].s;
          look.items.push(shoe.id);
          look.itemDetails.push(shoe);
          look.colors.push(shoe.color);
          look.score += 8;
        } else {
          look.missingItems.push({ emoji: '👠', name: 'Chaussures assorties', category: 'Chaussures', price: 59 });
          look.score -= 10;
        }

        // Sac : aléatoire parmi tous les sacs disponibles
        if (normalized['Sacs'].length > 0) {
          const bag = normalized['Sacs'][Math.floor(rand() * normalized['Sacs'].length)];
          look.items.push(bag.id);
          look.itemDetails.push(bag);
          look.colors.push(bag.color);
          look.score += 6;
        }

        // v1.12.205 : Veste vs Manteau selon météo.
        // Très froid → Manteau prioritaire. Froid/tempéré → Veste OK, fallback Manteau.
        const useCoat = ['very_cold','cold'].includes(weather);
        const outerCat = useCoat && normalized['Manteaux']?.length > 0 ? 'Manteaux'
                       : (['cold','very_cold','rainy','temperate'].includes(weather) && normalized['Vestes']?.length > 0) ? 'Vestes'
                       : (normalized['Manteaux']?.length > 0 ? 'Manteaux' : null);
        if (outerCat) {
          const piece = normalized[outerCat][Math.floor(rand() * normalized[outerCat].length)];
          look.items.push(piece.id);
          look.itemDetails.push(piece);
          look.score += outerCat === 'Manteaux' ? 7 : 5;
        }

        // Bijoux/Accessoires : aléatoire
        ['Bijoux','Accessoires'].forEach(accCat => {
          if (normalized[accCat].length > 0) {
            const acc = normalized[accCat][Math.floor(rand() * normalized[accCat].length)];
            look.items.push(acc.id);
            look.itemDetails.push(acc);
            look.score += 3;
          }
        });

        look.score = Math.min(98, look.score);
        look.aiTip = getTip(occ, weather);
        if (look.items.length >= 2) candidates.push(look);
      });
    }

    // ── Stratégie 2 : Haut + Bas + accessories ──
    if (normalized['Hauts'].length > 0 && normalized['Bas'].length > 0) {
      normalized['Hauts'].forEach((haut, hi) => {
        normalized['Bas'].forEach((bas, bi) => {
          // Autoriser plus de combos (limiter seulement si beaucoup d'articles)
          if (hi > 2 && bi > 2) return;

          const colScore = colorScore(haut.color, bas.color);
          if (colScore < 40) return; // un peu moins strict qu'avant

          const look = {
            id: `tl_${occ}_hb_${hi}_${bi}`,
            name: OCC_LABEL[occ] || occ,
            occasion: occ,
            items: [haut.id, bas.id],
            itemDetails: [haut, bas],
            colors: [haut.color, bas.color],
            score: 60 + Math.round(colScore * 0.15),
            aiTip: '',
            missingItems: [],
          };

          // v1.12.205 + v1.12.210 : Veste ET Manteau possibles (layering).
          const isCold = ['cold','very_cold'].includes(weather);
          const veryCold = weather === 'very_cold';
          // Si very_cold : on prend manteau + veste si dispo (layering)
          // Sinon cold : un des deux suffit (priorité veste mi-saison)
          if (veryCold && normalized['Manteaux']?.length > 0) {
            const m = normalized['Manteaux'][Math.floor(rand() * normalized['Manteaux'].length)];
            look.items.push(m.id); look.itemDetails.push(m);
            look.score += 8;
            // Layering optionnel veste sous manteau
            if (normalized['Vestes']?.length > 0 && rand() > 0.5) {
              const v = normalized['Vestes'][Math.floor(rand() * normalized['Vestes'].length)];
              look.items.push(v.id); look.itemDetails.push(v);
              look.score += 4;
            }
          } else if (isCold && normalized['Vestes']?.length > 0) {
            const v = normalized['Vestes'][Math.floor(rand() * normalized['Vestes'].length)];
            look.items.push(v.id); look.itemDetails.push(v);
            look.score += 7;
          } else if (isCold && normalized['Manteaux']?.length > 0) {
            const m = normalized['Manteaux'][Math.floor(rand() * normalized['Manteaux'].length)];
            look.items.push(m.id); look.itemDetails.push(m);
            look.score += 6;
          } else if (isCold) {
            look.missingItems.push({ emoji: '🧥', name: 'Manteau ou veste', category: 'Manteaux', price: 149 });
          }

          // Chaussures : top 3 + aléatoire
          if (normalized['Chaussures'].length > 0) {
            const scored = normalized['Chaussures']
              .map(s => ({ s, score: colorScore(haut.color, s.color) }))
              .sort((a, b) => b.score - a.score);
            const pool = scored.slice(0, Math.min(3, scored.length));
            const shoe = pool[Math.floor(rand() * pool.length)].s;
            look.items.push(shoe.id);
            look.itemDetails.push(shoe);
            look.score += 8;
          } else {
            look.missingItems.push({ emoji: '👟', name: 'Chaussures', category: 'Chaussures', price: 55 });
          }

          // Sac : aléatoire
          if (normalized['Sacs'].length > 0) {
            const bag = normalized['Sacs'][Math.floor(rand() * normalized['Sacs'].length)];
            look.items.push(bag.id);
            look.itemDetails.push(bag);
            look.score += 5;
          }

          // Bijoux : aléatoire
          if (normalized['Bijoux'].length > 0) {
            const bijou = normalized['Bijoux'][Math.floor(rand() * normalized['Bijoux'].length)];
            look.items.push(bijou.id);
            look.itemDetails.push(bijou);
            look.score += 3;
          }

          look.score = Math.min(98, look.score);
          look.aiTip = getTip(occ, weather);
          if (look.items.length >= 3) candidates.push(look);
        });
      });
    }

    // Trier par score, prendre les N meilleurs par occasion
    candidates.sort((a, b) => b.score - a.score);
    candidates.slice(0, maxPerOccasion).forEach(look => looks.push(look));
  });

  // Dédupliquer les looks identiques (mêmes items)
  const seenKeys = new Set();
  const unique = looks.filter(look => {
    const key = [...look.items].sort().join(',');
    if (seenKeys.has(key)) return false;
    seenKeys.add(key);
    return true;
  });

  // Respect limite totale configurable
  const sortedUnique = unique.sort((a, b) => b.score - a.score);
  return sortedUnique.slice(0, maxTotal);
}
